import React, { useContext, useEffect, useState } from 'react'
import { useGridApiRef } from '@mui/x-data-grid-pro'

import api from '../../../services/api'
import { displayMessage } from '../../../helpers/messages'
import SL_Button from '../../../components/buttons/Button'
import GeneralContext from '../../../context/GeneralContext/GeneralContext'
import { UserAddOutlined, EditOutlined, LockOutlined } from '@ant-design/icons'
import { ResetUserPasswordModal } from '../../user/components/ResetUserPasswordModal'
import CreateUser from '../../user/components/CreateUser'
import column_grid_user_list from '../../grid_columns/column_grid_user_list'
import styles from '../../../services/styles';
import { useNavigate, useParams } from "react-router-dom";
import { Button } from 'antd'
import { SL_Grid } from '../../../components/grid/SL_Grid'


const { tc1, tc2, bc2, bc6 } = styles


export default function ListUsersFromClient({ client }) {
    const [isModalCreateUserVisible, setIsModalCreateUserVisible] = useState(false)
    const [isModalResetPasswordVisible, setIsModalResetPasswordVisible] = useState(false)
    const [users, setUsers] = useState([])
    const [currentUser, setCurrentUser] = useState(null)
    const [clientsList, setClientsList] = useState(null)
    const { idClient } = useParams()
    const navigate = useNavigate()


    const gridRef = useGridApiRef()
    const {
        setShowLoading,
        windowHeight,
        mobile_mode
    } = useContext(GeneralContext)

    useEffect(() => {
        if (client?.id) {
            loadUsersFromClientDataLoad()
        } else {
            setUsers([])
        }
    }, [client])

    const loadUsersFromClientDataLoad = async () => {
        setShowLoading(true)
        try {
            let tempClientList = await api.client.list()
            setClientsList(tempClientList.data)
            loadUsersFromClientData()
            setCurrentUser(null)
        } catch (error) {
            console.error(error)
        } finally {
            setShowLoading(false)
        }
    }

    async function loadUsersFromClientData() {
        try {
            const id = client.id
            const rs = await api.client.listClients(id)
            gridRef.current.setSelectionModel([])
            setUsers(rs.data)

        } catch (error) {
            console.log(error)
        }
    }

    const handleGoToUserDetail = () => {
        navigate(`users/${currentUser?.id}`)
    }

    const handleOnOpenModalCreateUser = () => {
        setIsModalCreateUserVisible(true)
    }
    const handleOnCloseModalCreateUser = () => {
        setIsModalCreateUserVisible(false)
    }

    const handleOnOpenModalResetPassword = () => {
        setIsModalResetPasswordVisible(true)
    }
    const handleOnCloseModalResetPassword = () => {
        setIsModalResetPasswordVisible(false)
    }

    const toggleActiveState = async (info) => {
        setShowLoading(true)

        try {
            await api.user.changeActive(info?.id)
            await loadUsersFromClientData()
        } finally {
            setShowLoading(false)
        }
    }

    function onRowClickGridUser(e) {
        setCurrentUser(e?.row)
    }

    const extraColumn = {
        field: 'is_active_toggle',
        headerName: 'Situação',
        sortable: false,
        headerAlign: 'start',
        flex: 1,
        // align: 'start',
        renderCell: function (params) {
            return (
                <div style={{ padding: 2 }}>
                    <Button
                        style={{ minWidth: 80 }}
                        type={'primary'}
                        danger={params.row.is_active ? false : true}
                        onClick={() => toggleActiveState(params?.row)}
                    >
                        {params.row.is_active ? displayMessage('IS_ACTIVE') : displayMessage('IS_INACTIVE')}
                    </Button>
                </div>
            )
        }
    }

    return (
        <>
            {isModalCreateUserVisible && <CreateUser idClient={idClient} handleOnCloseModal={handleOnCloseModalCreateUser} refreshUsers={loadUsersFromClientDataLoad} clientsList={clientsList} />}
            {isModalResetPasswordVisible && <ResetUserPasswordModal user={currentUser} onCloseModal={handleOnCloseModalResetPassword} />}

            <div className='h-full flex flex-col'>
                <div
                    className={`flex w-full bg-fit-red-700 p-2 rounded-tl-[4px] rounded-tr-[4px] flex-wrap ${mobile_mode ? 'flex-col items-center gap-4' : 'gap-2'}`}
                >
                    <div className='self-center text-white font-semibold text-base'>{displayMessage('USER_LIST')}</div>

                    <div className='flex-1 flex flex-wrap justify-end gap-2'>
                        <SL_Button
                            type='default'
                            className={`flex items-center flex-1 ${mobile_mode ? 'w-[200px]' : 'max-w-[200px]'}`}
                            onClick={handleOnOpenModalResetPassword}
                            disabled={!currentUser}
                            icon={<LockOutlined className='text-fit-blue-800 text-base flex items-center' />}
                        >
                            <span className='text-fit-blue-800 font-semibold flex-1' >
                                {displayMessage('REQUEST_PASSWORD_RESET')}
                            </span>
                        </SL_Button>

                        <SL_Button
                            type='default'
                            className={`flex items-center flex-1 ${mobile_mode ? 'w-[200px]' : 'max-w-[200px]'}`}
                            onClick={handleGoToUserDetail}
                            icon={<EditOutlined className='text-fit-blue-800 text-base flex items-center' />}
                            disabled={!currentUser}
                        >
                            <span className='text-fit-blue-800 font-semibold flex-1'>
                                {displayMessage('DETAIL_USER')}
                            </span>
                        </SL_Button>

                        <SL_Button
                            type='default'
                            className={`flex items-center flex-1 ${mobile_mode ? 'w-[200px]' : 'max-w-[200px]'}`}
                            onClick={handleOnOpenModalCreateUser}
                            icon={<UserAddOutlined className='text-fit-blue-800 text-base flex items-center' />}
                        >
                            <span className='text-fit-blue-800 font-semibold flex-1'>
                                {displayMessage('CREATE_USER')}
                            </span>
                        </SL_Button>
                    </div>
                </div>

                <div style={{ width: '100%', flex: 1 }}>
                    <SL_Grid
                        rows={users ?? []}
                        apiRef={gridRef}
                        columns={column_grid_user_list.concat(extraColumn)}
                        onRowClick={onRowClickGridUser}
                        style={{ marginBottom: 50 }}
                    />
                </div>
            </div>
        </>
    )
}